(function () {
  'use strict';

  function init() {
    if (typeof IntersectionObserver !== 'undefined') {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('show');
            obs.unobserve(e.target);
          }
        });
      }, { threshold: 0.1 });

      document.querySelectorAll('.reveal').forEach(function (el) {
        obs.observe(el);
      });
    } else {
      document.querySelectorAll('.reveal').forEach(function (el) {
        el.classList.add('show');
      });
    }

    initIndexLinks();
  }

  /* Index drawer: every link inside it closes the drawer. Same-page anchors scroll smoothly after it closes. */
  function initIndexLinks() {
    var idx = document.getElementById('siteIndex');
    if (!idx) return;
    var closeBtn = idx.querySelector('[data-index-close]');
    function closeDrawer() {
      if (closeBtn) { closeBtn.click(); return; }
      idx.classList.remove('is-open');
      idx.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('site-index-locked');
    }
    idx.querySelectorAll('.site-index-links a').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        var hashAt = href.indexOf('#');
        if (hashAt !== -1) {
          var path = href.slice(0, hashAt).replace(/\/$/, '');
          var here = window.location.pathname.replace(/\/$/, '');
          var target = document.querySelector(href.slice(hashAt));
          if (target && (path === '' || path === here)) {
            e.preventDefault();
            closeDrawer();
            setTimeout(function () {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              if (history.replaceState) history.replaceState(null, '', href.slice(hashAt));
            }, 350);
            return;
          }
        }
        closeDrawer();
      });
    });
  }

  window.handleSubscribe = function (e) {
    e.preventDefault();
    alert('Thank you for subscribing!');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
